import { styled } from 'styled-components';
import { Box } from '@design-system/box';
export const Overlay = styled(Box) `
  background-color: ${({ theme }) => theme.colors.fog};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: ${({ theme }) => theme.zIndices.modal - 1};
`;
//# sourceMappingURL=Overlay.js.map